import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest,HTTP_INTERCEPTORS } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
// import {LoginService} from '../../../src/app/_root/Trai_module/_services/login/API-login';

/**
 * This interceptor automatically adds the token header needed by our backend API if such token is present
 * in the current state of the application.
 */
@Injectable({				
  providedIn: 'root'
})
export class Interceptor implements HttpInterceptor {

  constructor() {}
//   constructor(private loginService: LoginService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    console.log('INTERCEPTOR');
    // const token = this.loginService.getAuthToken();
    //     console.log('token',token);
        // req = req.clone({headers: req.headers.set('Ocp-Apim-Subscription-Key', 'f4c53aa4ce174d0da756e62ab5df9a79')});
 req = req.clone({headers: req.headers.set('Ocp-Apim-Subscription-Key', '2215b252163046d09b5b3cfffe8c9390')});
  
    return next.handle(req);
    
  }
}
export const InterceptorOCP = {
    provide: HTTP_INTERCEPTORS,
    useClass: Interceptor,
    multi: true,
};

